import axios from "axios";
import { APP_DATA } from "../config/settings";

let instance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
});
instance.interceptors.request.use(req => {
        req.headers['Authorization'] = localStorage.getItem('idToken');
        return req;
    }, error => {
        return Promise.reject(error);
    }
);
//on successful response
instance.interceptors.response.use(
    undefined, function axiosRetryInterceptor(err) {
        // console.log(err);
        if (err.response.status === 403 || err.response.status === 401) {
            const url =  window.location.origin + '/#' + APP_DATA.LOGIN_ROUTE;
            // console.log(url)
            window.location.href= url;
            // console.log(url)
            // console.log(window.location)
        }
        else if(err.response.status === 400){
            return err.response
        }
        else {
            return err;
        }
    }
);
export default instance;
